<template>
  <div>
    <video
      :id="'lesson_images__video-' + file.id"
      :src="link"
      controls="controls"
      @play="isButtonShow = false"
      @pause="isButtonShow = true"
    >
      <source :src="link" type="video/mp4" />
    </video>
    <button :id="'lesson_images__button-' + file.id" @click="playVideo(file.id)" v-if="file.type == 3 && isButtonShow">
      <i class="mdi mdi-play-circle-outline"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      default: () => {},
      type: Object
    },
    link: {
      default: () => '',
      type: String
    }
  },
  data() {
    return {
      isButtonShow: true
    }
  },
  methods: {
    playVideo(ID) {
      document.getElementById('lesson_images__video-' + ID).play()
    }
  }
}
</script>
